(function($) {

  const amenities = {
    dom: function() {
      this.$toggleAmenity = $('#toggle-amenity');
      this.$toggleAmenityGroup = $('[data-js-hook="toggle-amenity-group"]');
      this.$hiddenAmenity = $('[data-js-hook="hidden-amenity"]');
      this.$rotator = $('[data-js-hook="amenities-rotator"]');
    },

    tabs: function() {
      const tabs = new tabbytabtab($('[data-js-hook="amenity-tabs"]'));

      tabs.onTab(function($this){
        let $category = $('[data-amenities="' + $this.data('toggle-amenities') + '"]');

        if ($category.length) {
          $('[data-amenities]').hide();

          $category.show().find('[data-manual-src]').each(function(){
            if (!$(this).hasClass('loaded')) {
              if ($(this).get(0).tagName == 'IMG') {
                $(this)
                  .attr('src', $(this).data('manual-src'))
                  .removeAttr('data-manual-src')
                  .load(function(){
                    $(this).addClass('loaded');
                  })
              } else {
                $(this)
                  .css('background-image', 'url(' + $(this).data('manual-src') + ')')
                  .removeAttr('data-manual-src')
                  .addClass('loaded');
              }
            }
          });
        }
      });
    },

    toggleAmenities: function() {
      this.$toggleAmenityGroup.click(function(e) {
        e.preventDefault();
        let $hiddenAmenities = amenities.$hiddenAmenity.filter('[data-amenity-group=' + $(this).data('amenity-group') + ']');
        let $this = $(this);

        $(this).toggleClass('expanded');

        $hiddenAmenities.slideToggle(200, function() {
          let visible = $hiddenAmenities.first().is(':visible');
          $this.find('[data-js-hook="expand-icon"]').html(visible ? '&times;' : '+');
          $this.find('[data-js-hook="expand-verbiage"]').html(visible ? 'Show Less' : 'Show More');
        });
      });

      this.$toggleAmenity.click(function(e) {
        e.preventDefault();
        let $this = $(this);

        $(this).toggleClass('expanded');

        amenities.$hiddenAmenity.slideToggle(200, function() {
          let visible = amenities.$hiddenAmenity.first().is(':visible');
          $this.find('[data-js-hook="expand-verbiage"]').text(visible ? 'Show Less' : 'Show More');
        });
      });
    },

    rotator: function() {
      if (this.$rotator.length) {
        this.$rotator.addClass('flexslider').flexslider({
          controlNav: true,
          directionNav: false
        });
      }
    },

    ready: function() {
      this.dom();
      this.tabs();
      this.toggleAmenities();
      this.rotator();
    }
  }

  $(function() {
    amenities.ready();
  });

})(jQuery);
